import { useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';
import { FaqsPageContent } from '@starjack/widgets/faqs';
import { useAuthentication } from '@starjack/features/authentication';
import { Faq } from '@starjack/entities/faq';

export const FaqPage: PageWithLayout = () => {
    const { liftOperatorData } = useAuthentication();

    const canMutateFaq = useCallback(
        (faq: Faq) => faq.liftOperatorId === liftOperatorData?.liftOperatorId,
        [liftOperatorData?.liftOperatorId]
    );

    return (
        <>
            <Helmet>FAQs | Starjack Admin</Helmet>
            <FaqsPageContent
                canMutateFaq={canMutateFaq}
                liftOperatorId={liftOperatorData?.liftOperatorId}
            />
        </>
    );
};

FaqPage.isProtected = true;
FaqPage.permissions = [Permission.FAQ_NAV];
FaqPage.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;

export default FaqPage;
